// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page .multiple-choice-cards {
  grid-template-columns: repeat(1, 1fr);
}
.page .cards {
  --grid-table: 0.8fr 0.5fr 1fr 0.8fr;
  display: grid;
  grid-template-columns: repeat(1, minmax(100px, 1fr));
  gap: 0px 20px;
}
.page .cards .card {
  box-shadow: none;
}
.page .cards .card .remove-btn {
  text-decoration: underline;
  text-transform: none;
}
.page .cards .card .body {
  padding: var(--padding);
  display: flex;
  align-items: center;
  font-size: var(--font-secondary);
  color: var(--color-primary);
  font-weight: var(--weight-normal);
}
.page .cards .card .body.pe {
  padding: 1rem;
}
.page .cards .card .body .small {
  font-size: var(--font-secondary);
  color: var(--color-secondary);
}
.page .cards .card .body .title {
  font-size: var(--font-header);
}
.page .cards .card .body .selected {
  background-color: rgba(var(--app-main-softer-rgb), 0.25);
}
.page .cards .card .body.border {
  border-bottom: var(--border-divider);
}
.page .cards .card .body ion-badge {
  --background: #D3CDCD;
}
.page .cards .card .recent-shipping {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}
.page .cards .card .recent-shipping ion-card {
  margin-bottom: 34px;
  height: 100%;
  flex-grow: 1;
  flex-basis: 0;
}
.page .cards .card .recent-shipping ion-card ion-card-header ion-card-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.page .cards .card .recent-shipping ion-card ion-card-content {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.page .container {
  padding: var(--padding);
  display: flex;
  flex-direction: column;
  font-size: var(--font-secondary);
  color: var(--color-primary);
  font-weight: var(--weight-normal);
}
.page .container .title {
  margin-bottom: 15px;
  color: var(--app-mid);
  font-size: 18px;
  font-weight: 500;
}
.page .container .multiple-choice-cards {
  margin: 30px 30px;
}
.page .container .description {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: column;
  font-size: var(--font-label);
}
.page .container .description .item-column {
  display: flex;
  flex-direction: column;
  color: var(--app-mid);
  align-items: center;
  align-content: center;
  justify-content: space-between;
}
.page .container .description .item-column span {
  font-size: var(--font-secondary);
}
.page .container .description .item-column .box-info {
  font-size: var(--font-header);
  font-weight: var(--weight-normal);
  box-shadow: var(--box-shadow);
  padding: 0.5rem;
  border-radius: var(--border-radius);
  gap: 1rem;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}

.gap-d {
  gap: 0.5rem;
}

.modal_alarm {
  --height: 100%;
}

app-invoice-cost-details {
  width: 90%;
}

.swiper-pagination {
  position: relative;
  bottom: 0;
}

#payment-element {
  width: 70%;
}

.follow-order {
  color: var(--color-secondary);
  font-size: var(--font-header);
  margin-top: 4rem;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  display: flex;
  flex-direction: column;
}

swiper-container {
  width: 100% !important; /* Assicura che il contenitore occupi tutta la larghezza */
  height: auto !important; /* Altezza automatica */
}

swiper-slide {
  flex-shrink: 0 !important; /* Impedisce il ridimensionamento delle slide */
  width: auto !important; /* Consente a Swiper di calcolare le dimensioni in base a slidesPerView */
}

.swiper-slide {
  background: lightblue;
  border: 1px solid #ddd;
  text-align: center;
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/mobile/common/finalize-order/finalize-order.page.scss"],"names":[],"mappings":"AAEE;EACD,qCAAA;AADD;AAIE;EACD,mCAAA;EACA,aAAA;EACA,oDAAA;EACA,aAAA;AAFD;AAGC;EACE,gBAAA;AADH;AAEG;EACD,0BAAA;EACA,oBAAA;AAAF;AAGG;EACD,uBAAA;EAMA,aAAA;EACA,mBAAA;EAeA,gCAAA;EACA,2BAAA;EACA,iCAAA;AApBF;AAFE;EACE,aAAA;AAIJ;AAEE;EACE,gCAAA;EACA,6BAAA;AAAJ;AAGE;EACE,6BAAA;AADJ;AAIE;EACE,wDAAA;AAFJ;AAUE;EACE,oCAAA;AARJ;AAWE;EACE,qBAAA;AATJ;AAeG;EACD,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAbF;AAcE;EACI,mBAAA;EAaF,YAAA;EACA,YAAA;EACA,aAAA;AAxBJ;AAWG;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AATL;AAYI;EACD,uBAAA;EACA,mBAAA;EACA,gBAAA;AAVH;AAoBE;EACD,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,2BAAA;EACA,iCAAA;AAlBD;AAoBC;EACE,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAlBH;AAqBC;EACE,iBAAA;AAnBH;AAsBC;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,4BAAA;AApBH;AAsBG;EACD,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AApBF;AAqBE;EACE,gCAAA;AAnBJ;AAsBE;EACE,6BAAA;EACA,iCAAA;EACA,6BAAA;EACA,eAAA;EACA,mCAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AApBJ;;AA6BA;EACE,WAAA;AA1BF;;AA8BA;EACE,cAAA;AA3BF;;AA+BA;EACE,UAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,SAAA;AA5BF;;AA+BA;EACE,UAAA;AA5BF;;AA+BA;EACE,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AA5BF;;AA8BA;EACE,sBAAA,EAAA,0DAAA;EACA,uBAAA,EAAA,uBAAA;AA3BF;;AA8BA;EACE,yBAAA,EAAA,+CAAA;EACA,sBAAA,EAAA,yEAAA;AA3BF;;AA8BA;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AA3BF","sourcesContent":[".page{\n\n  .multiple-choice-cards{\n\tgrid-template-columns: repeat(1, 1fr);\n  }\n\n  .cards{\n\t--grid-table: 0.8fr 0.5fr 1fr 0.8fr;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(1, minmax(100px, 1fr));\n\tgap: 0px 20px;\n\t.card{\n\t  box-shadow: none;\n\t  .remove-btn{\n\t\ttext-decoration: underline;\n\t\ttext-transform: none;\n\t  }\n\n\t  .body{\n\t\tpadding: var(--padding);\n\n\t\t&.pe{\n\t\t  padding: 1rem;\n\t\t}\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t.small{\n\t\t  font-size: var(--font-secondary);\n\t\t  color: var(--color-secondary);\n\t\t}\n\n\t\t.title{\n\t\t  font-size: var(--font-header);\n\t\t}\n\n\t\t.selected{\n\t\t  background-color: rgba(var(--app-main-softer-rgb), .25);\n\t\t}\n\n\t\tfont-size: var(--font-secondary);\n\t\tcolor: var(--color-primary);\n\t\tfont-weight: var(--weight-normal);\n\n\n\t\t&.border{\n\t\t  border-bottom: var(--border-divider);\n\t\t}\n\n\t\tion-badge{\n\t\t  --background: #D3CDCD;\n\t\t}\n\n\n\t  }\n\n\t  .recent-shipping{\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 1rem;\n\t\tion-card{\n      margin-bottom: 34px;\n\t\t  ion-card-header{\n\t\t\tion-card-title{\n\t\t\t  text-overflow: ellipsis;\n\t\t\t  white-space: nowrap;\n\t\t\t  overflow: hidden;\n\t\t\t}\n\t\t  }\n\t\t  ion-card-content{\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t  }\n\t\t  height: 100%;\n\t\t  flex-grow: 1;\n\t\t  flex-basis: 0;\n\t\t}\n\t  }\n\t}\n  }\n\n  .container{\n\tpadding: var(--padding);\n\tdisplay: flex;\n\tflex-direction: column;\n\tfont-size: var(--font-secondary);\n\tcolor: var(--color-primary);\n\tfont-weight: var(--weight-normal);\n\n\t.title{\n\t  margin-bottom: 15px;\n\t  color: var(--app-mid);\n\t  font-size: 18px;\n\t  font-weight: 500;\n\t}\n\n\t.multiple-choice-cards{\n\t  margin: 30px 30px;\n\t}\n\n\t.description {\n\t  display: flex;\n\t  gap: 1rem;\n\t  justify-content: center;\n\t  align-items: center;\n\t  align-content: center;\n\t  flex-direction: column;\n\t  font-size: var(--font-label);\n\n\t  .item-column{\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tcolor: var(--app-mid);\n\t\talign-items: center;\n\t\talign-content: center;\n\t\tjustify-content: space-between;\n\t\tspan{\n\t\t  font-size: var(--font-secondary);\n\t\t}\n\n\t\t.box-info{\n\t\t  font-size: var(--font-header);\n\t\t  font-weight: var(--weight-normal);\n\t\t  box-shadow: var(--box-shadow);\n\t\t  padding: 0.5rem;\n\t\t  border-radius: var(--border-radius);\n\t\t  gap: 1rem;\n\t\t  display:flex;\n\t\t  justify-content: center;\n\t\t  text-align: center;\n\t\t  align-items: center;\n\t\t}\n\t  }\n\t}\n\n  }\n\n}\n\n.gap-d{\n  gap: 0.5rem;\n}\n\n\n.modal_alarm{\n  --height: 100%;\n}\n\n\napp-invoice-cost-details{\n  width: 90%;\n}\n\n.swiper-pagination{\n  position: relative;\n  bottom: 0;\n}\n\n#payment-element{\n  width: 70%;\n}\n\n.follow-order{\n  color: var(--color-secondary);\n  font-size: var(--font-header);\n  margin-top: 4rem;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  display: flex;\n  flex-direction: column;\n}\nswiper-container {\n  width: 100%!important; /* Assicura che il contenitore occupi tutta la larghezza */\n  height: auto!important; /* Altezza automatica */\n}\n\nswiper-slide {\n  flex-shrink: 0!important; /* Impedisce il ridimensionamento delle slide */\n  width: auto!important; /* Consente a Swiper di calcolare le dimensioni in base a slidesPerView */\n}\n\n.swiper-slide {\n  background: lightblue;\n  border: 1px solid #ddd;\n  text-align: center;\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
